// @ts-ignore
export const dev = process.env.NODE_ENV != "production";
export const browser = true;
console.log(JSON.stringify({ dev, browser }));
